import { ensureJobCorn } from '@eigtech/restoration-util'
import { queryOptions, useQuery, useQueryClient } from '@eigtech/ui-shared-api'
import { assignmentsQueryKeys, getAssignablesForAssignee } from '@eigtech/ui-shared-assignments'

export function getAssignablesForJobQueryOptions(jobId: string) {
  const jobCorn = ensureJobCorn(jobId)

  return queryOptions({
    queryKey: assignmentsQueryKeys.assignee.assignables(jobCorn),
    queryFn: () => getAssignablesForAssignee({ assigneeId: jobCorn }),
    enabled: !!jobId,
  })
}

export const useGetAssignablesForJob = (jobId: string) =>
  useQuery(getAssignablesForJobQueryOptions(jobId))

export function useInvalidateAssignablesForJob() {
  const queryClient = useQueryClient()

  return function invalidateAssignablesForJob(jobId: string) {
    queryClient.invalidateQueries({ queryKey: getAssignablesForJobQueryOptions(jobId).queryKey })
  }
}
